import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
import { VTabsSlider } from 'vuetify/lib/components/VTabs';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.deviceData ? _c(VContainer, {
    staticClass: "pa-0",
    attrs: {
      "fluid": ""
    }
  }, [_c(VDialog, {
    attrs: {
      "max-width": "900"
    },
    model: {
      value: _vm.formDialog,
      callback: function ($$v) {
        _vm.formDialog = $$v;
      },
      expression: "formDialog"
    }
  }, [_vm.formDialog ? _c('niota-classic-devices-edit-form', {
    attrs: {
      "editedItem": _vm.deviceData,
      "applications": _vm.applications,
      "deviceTypes": _vm.deviceTypes,
      "datasourceType": _vm.datasourceType
    },
    on: {
      "close": function ($event) {
        _vm.formDialog = false;
      },
      "refreshList": _vm.refresh
    }
  }) : _vm._e()], 1), _c(VDialog, {
    attrs: {
      "max-width": "900"
    },
    model: {
      value: _vm.csvExportDialog,
      callback: function ($$v) {
        _vm.csvExportDialog = $$v;
      },
      expression: "csvExportDialog"
    }
  }, [_vm.csvExportDialog ? _c('niota-classic-devices-export-form', {
    attrs: {
      "device": _vm.deviceData
    },
    on: {
      "close-export-dialog": function ($event) {
        _vm.csvExportDialog = false;
      }
    }
  }) : _vm._e()], 1), _c(VDialog, {
    attrs: {
      "max-width": "900"
    },
    model: {
      value: _vm.qrScanner,
      callback: function ($$v) {
        _vm.qrScanner = $$v;
      },
      expression: "qrScanner"
    }
  }, [_vm.qrScanner ? _c('niota-classic-devices-qr-form', {
    attrs: {
      "title": _vm.$i18n_t('NiotaClassic.Devices.form.qrDevice')
    },
    on: {
      "close": function ($event) {
        _vm.qrScanner = false;
      }
    }
  }) : _vm._e()], 1), _c('core-header', {
    attrs: {
      "headerBG": "./img/transparent.png",
      "subtitle": `${_vm.$i18n_t('NiotaClassic.Devices.form.deviceId')}: ${_vm.deviceData.id}`
    },
    scopedSlots: _vm._u([{
      key: "headline",
      fn: function () {
        return [_vm.deviceData.deviceType && _vm.deviceData.deviceType.image ? _c('img', {
          staticClass: "device-image",
          attrs: {
            "width": "45",
            "height": "45",
            "src": _vm.getDeviceImageUrl(_vm.deviceData.deviceType.image)
          }
        }) : _c(VIcon, {
          class: _vm.color + '--text headline-icon mr-1',
          domProps: {
            "textContent": _vm._s(`fal fa-sensor-on`)
          }
        }), _vm._v("\n      " + _vm._s(_vm.deviceData.title) + "\n    ")];
      },
      proxy: true
    }, {
      key: "buttons",
      fn: function () {
        return [_c('core-button', {
          attrs: {
            "color": _vm.color,
            "title": _vm.$i18n_t('NiotaClassic.Devices.form.csvExport'),
            "prepend-icon": "fa-file-csv",
            "disabled": !Object.keys(_vm.parsedPackets).length
          },
          on: {
            "click": function ($event) {
              _vm.csvExportDialog = true;
            }
          }
        }), _c('core-button', {
          attrs: {
            "color": _vm.color,
            "title": _vm.$i18n_t('NiotaClassic.Devices.form.qrScanner'),
            "prepend-icon": "fa-qrcode",
            "disabled": !_vm.isIotHubManager
          },
          on: {
            "click": function ($event) {
              _vm.qrScanner = true;
            }
          }
        }), _c('core-button', {
          attrs: {
            "color": _vm.color,
            "title": _vm.$i18n_t('NiotaClassic.Devices.editButton'),
            "prepend-icon": _vm.isIotHubManager ? 'fa-edit' : 'fa-eye'
          },
          on: {
            "click": function ($event) {
              _vm.formDialog = true;
            }
          }
        }), _c('core-button', {
          attrs: {
            "color": "danger",
            "title": _vm.$i18n_t('Common.cancel'),
            "prepend-icon": "fa-times"
          },
          on: {
            "click": function ($event) {
              return _vm.viewAllDevices();
            }
          }
        })];
      },
      proxy: true
    }], null, false, 2169580331)
  }), _c(VRow, {
    staticClass: "n20-mainrow pb-4",
    staticStyle: {
      "min-width": "0"
    }
  }, [_c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c('core-n20Card', {
    staticClass: "mb-8"
  }, [_c(VTabs, {
    model: {
      value: _vm.tabItem,
      callback: function ($$v) {
        _vm.tabItem = $$v;
      },
      expression: "tabItem"
    }
  }, [_c(VTabsSlider, {
    attrs: {
      "color": _vm.color
    }
  }), _c(VTab, {
    attrs: {
      "href": "#details"
    }
  }, [_c(VIcon, {
    staticClass: "mr-3"
  }, [_vm._v("fal fa-book-open")]), !_vm.isMobile ? _c('span', [_vm._v(_vm._s(_vm.$i18n_t('NiotaClassic.Devices.details.details')))]) : _vm._e()], 1), Object.keys(_vm.parsedPackets).length && Object.keys(_vm.dynamicGraph).length ? _c(VTab, {
    attrs: {
      "href": "#packets-visualization"
    }
  }, [_c(VIcon, {
    staticClass: "mr-3"
  }, [_vm._v("fal fa-chart-line")]), !_vm.isMobile ? _c('span', [_vm._v(_vm._s(_vm.$i18n_t('NiotaClassic.Devices.details.packetsVisualization')))]) : _vm._e()], 1) : _vm._e(), _c(VTabsItems, {
    staticClass: "mt-4",
    attrs: {
      "touchless": ""
    },
    model: {
      value: _vm.tabItem,
      callback: function ($$v) {
        _vm.tabItem = $$v;
      },
      expression: "tabItem"
    }
  }, [_c(VTabItem, {
    key: "details",
    attrs: {
      "value": "details"
    }
  }, [_c('niota-classic-devices-device-details-form', {
    attrs: {
      "deviceId": _vm.deviceId,
      "datasourceType": _vm.datasourceType,
      "deviceData": _vm.deviceData,
      "packetsLoading": _vm.packetsLoading,
      "devicePackets": _vm.devicePackets,
      "keysDatasets": _vm.keysDatasets,
      "parsedPackets": _vm.parsedPackets,
      "btnDisabled": _vm.btnDisabled
    },
    on: {
      "load-more-packets": _vm.loadMorePackets,
      "loadParsedPackets": _vm.loadParsedPackets,
      "fetchDevicePackets": _vm.fetchDevicePacketsByDate
    }
  })], 1), _c(VTabItem, {
    key: "packets-visualization",
    attrs: {
      "value": "packets-visualization"
    }
  }, [_c('niota-classic-devices-device-details-visualization', {
    ref: "visualization",
    attrs: {
      "keysDatasets": _vm.keysDatasets,
      "allRelevantKeys": _vm.allRelevantKeys,
      "isLoadingGraph": _vm.isLoadingGraph,
      "showLoadMorePackets": _vm.showLoadMorePackets,
      "visualizeGraphsToggle": _vm.visualizeGraphsToggle,
      "dynamicGraph": _vm.dynamicGraph,
      "isLoading": _vm.isLoading,
      "parsedPacketsSize": _vm.parsedPacketsSize
    },
    on: {
      "loadParsedPackets": _vm.loadParsedPacketsForVisualization
    }
  })], 1)], 1)], 1)], 1)], 1)], 1)], 1) : _vm._e();
};
var staticRenderFns = [];
export { render, staticRenderFns };